import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectRequestTemplateData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.requestTemplateData

export const selectRequestTemplateLoadingStatus = createSelector(
  [selectRequestTemplateData],
  ({ status }) => status
)
